import React from "react";

const overlayStyles = `
  .che-loader,
  .che-loader:before,
  .che-loader:after {
    border-radius: 50%;
    width: 2.5em;
    height: 2.5em;
    animation-fill-mode: both;
    animation: cheLoad7 1.8s infinite ease-in-out;
  }
  .che-loader {
    color: #ffffff;
    font-size: 10px;
    margin: 40px auto;
    position: relative;
    text-indent: -9999em;
    transform: translateZ(0);
    animation-delay: -0.16s;
  }
  .che-loader:before,
  .che-loader:after {
    content: '';
    position: absolute;
    top: 0;
  }
  .che-loader:before {
    left: -3.5em;
    animation-delay: -0.32s;
  }
  .che-loader:after {
    left: 3.5em;
  }
  @keyframes cheLoad7 {
    0%, 80%, 100% { box-shadow: 0 2.5em 0 -1.3em; }
    40% { box-shadow: 0 2.5em 0 0; }
  }
`;

export default function LoadingOverlay({
  show,
  message = "Processing your request...",
}) {
  if (!show) return null;
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <style>{overlayStyles}</style>
      <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <div className="che-loader">Loading...</div>
      </div>
      <div className="mt-4 text-center" style={{ color: "#ffffff", fontWeight: 300, fontSize: "16px" }}>
        {message}
      </div>
    </div>
  );
}
